import styled from 'styled-components'
import theme from '../../../../styles/theme'

export const ItemsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 0.55rem;
  border-left: ${theme.borderDefault};
  border-right: ${theme.borderDefault};
  border-bottom: ${theme.borderDefault};
`

export const Item = styled.div`
  flex-grow: 0;
  max-width: 25%;
  flex-basis: 25%;
  box-sizing: border-box;
  padding: 0.55rem;
  & > img {
    display: block;
    width: 100%;
    height: auto;
  }
`
